import { getYear } from './get-year.js';
import documentReady from './common/actions';
import { addHeaderClickListener, headerAnimation } from './common/header';
import { recordMouseClickEvents } from './common/analytics';

function callBack() {
  addHeaderClickListener();
  headerAnimation();
  window.addEventListener('click', recordMouseClickEvents);
}

documentReady(callBack);

const isProduction = process.env.NODE_ENV === 'PRODUCTION';
class ActionContactusPage {
  addEventListener() {
    const sendButton = document.getElementById('send-btn');
    if (sendButton) {
      sendButton.addEventListener('click', () => this.onClickContactUs());
    }
    const startChatButton = document.getElementById('start-chat-btn');
    if (startChatButton) {
      startChatButton.addEventListener('click', () => {
        document.querySelector('.cw-initiate-video').click();
      });
    }
  }

  emailValidation(email) {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  onClickContactUs() {
    const emailId = document.getElementById('emailInput').value;
    console.log(`user ${emailId} is trying to contact`);
    const emailValidation = this.emailValidation(emailId);
    if (emailValidation) {
      const name = document.getElementById('nameInput').value;
      const message = document.getElementById('messageInput').value;
      const url = `${
        isProduction
          ? 'https://teleport.video'
          : 'https://staging.teleport.video'
      }/api/client/v1/sendContactInfo`;
      fetch(url, {
        method: 'POST',
        body: JSON.stringify({ emailId, name, message }),
        headers: {
          'content-type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 'success') {
            document.querySelector('.messageSuccess').style.display = 'block';
          }
        });
    } else {
      document.querySelector('.invalidMailid').style.display = 'block';
      setTimeout(() => {
        document.querySelector('.invalidMailid').style.display = 'none';
      }, 3000);
    }
  }
}

const actionContactusPage = new ActionContactusPage();

window.onload = () => {
  actionContactusPage.addEventListener();
  getYear();
};
